import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { UnitOfMeasure } from "@/app/services/generated/unitofmeasureService";
import { unitOfMeasureService } from "@/app/services/generated/unitofmeasureService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasUnitsOfMeasureCache {
  unitsOfMeasure: UnitsOfMeasuresCache;
}

// Singleton cache store
const unitsOfMeasuresCacheStore = new EntityCacheStore<UnitOfMeasure>(
  EnumCacheEntityType.unitOfMeasure,
  async () => unitOfMeasureService.getAllUnitsOfMeasure()
);

// Ephemeral reader
export default class UnitsOfMeasuresCache extends EntityWithGuidKeyCache<UnitOfMeasure> {
  constructor() {
    super(unitsOfMeasuresCacheStore, (x) => x.id);
  }

  /**
   * Gets the 'units' Unit of Measure
   */
  public getUnitsUom() {
    return this.all.find((uom) => uom.readOnly.isUnits)!.id;
  }
}
